import styled from '@emotion/styled';
import React, { useRef } from 'react';

/** firefox does not let us style the native date picker icon at all
 *  the simplest fix is to just cover it with an ::after element
 */
const DateContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;

  ::after {
    width: 25px;
    height: 25px;
    background: white;
    position: absolute;
    content: '';
    right: 3px;
    top: 12px;
  }
  @supports not selector(::-webkit-calendar-picker-indicator) {
    ::after {
      display: block;
    }
  }

  svg {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 1;
  }

  input {
    cursor: text;
    padding-left: 50px;
    line-height: 23px;

    &::-webkit-calendar-picker-indicator,
    &::-webkit-inner-spin-button,
    &::-webkit-clear-button {
      display: none;
      -webkit-appearance: none;
    }
  }
`;

export function resolveDate(val) {
  if (!val) return undefined;
  const date = new Date();
  if (val === 'today') return date.toISOString().split('T')[0];

  const match = val.match(/^([+-])(\d+)d$/);
  if (match) {
    const days = parseInt(match[2], 10);
    date.setDate(date.getDate() + (match[1] === '+' ? days : -days));
    return date.toISOString().split('T')[0];
  }
  return val;
}

const DateWidget = (props = {}) => {
  const { value, onChange, options, readonly, ...rest } = props;
  // throwing away invalid html props so we don't get a bunch of warnings
  /* eslint-disable no-unused-vars */
  const {
    autofocus,
    schema,
    uiSchema,
    registry,
    rawErrors,
    type,
    formContext,
    hideError,
    hideLabel,
    ...inputProps
  } = rest;
  /* eslint-enable no-unused-vars */

  const inputRef = useRef(null);

  const handleChange = e => {
    const newValue = e.target.value;
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleMouseDown = e => {
    e.preventDefault();
    inputRef.current.showPicker();
  };

  return (
    <DateContainer>
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="23"
        viewBox="0 0 24 24"
        fill="none"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        onMouseDown={handleMouseDown}
      >
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>

      <input
        readOnly={readonly}
        ref={inputRef}
        type="date"
        value={value || ''}
        onChange={handleChange}
        min={resolveDate(options.min)}
        max={resolveDate(options.max)}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...inputProps}
      />
    </DateContainer>
  );
};

export default DateWidget;
